/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in localStorage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    if (typeof productId !== 'string' || productId.length === 0) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (_) {
      // no-op
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch (_) {
      // no-op
    }
  }

  /**
   * Retrieves the list of recently viewed products from localStorage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const rawProducts = localStorage.getItem(this.#STORAGE_KEY);
      if (!rawProducts) return [];

      const viewedProducts = JSON.parse(rawProducts);
      if (!Array.isArray(viewedProducts)) return [];

      return viewedProducts.filter((productId) => typeof productId === 'string');
    } catch (_) {
      return [];
    }
  }
}
